import { useLocation, useNavigate } from "react-router-dom";
import { PageHeader, Tabs } from "@aawaz/ui";
import { ConnectionsPage } from "./Connections";
import { MirrorPage } from "./Mirror";
import { WhatsAppPage } from "./WhatsApp";

const TABS = [
  { value: "overview", label: "Overview" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "filing", label: "Drive filing" },
];

/** Every way documents come in and go out: the integration gallery, WhatsApp groups and numbers, and drive filing.
 *  `/connections/<id>?connected=1` (OAuth landing) opens the overview, which picks up the link step. */
export function ChannelsPage({ tab: forced }: { tab?: "accounts" }) {
  const loc = useLocation();
  const navigate = useNavigate();
  const sub = loc.pathname.split("/")[2] ?? "";
  const tab = forced ? "overview" : TABS.some((t) => t.value === sub) ? sub : "overview";
  return (
    <>
      <PageHeader title="Channels" description="Where documents come in, where filed copies go, and the accounting software AawazAI keeps in sync." />
      <Tabs tabs={TABS} value={tab} onChange={(v) => navigate(v === "overview" ? "/channels" : `/channels/${v}`)} />
      {tab === "whatsapp" ? <WhatsAppPage /> : tab === "filing" ? <MirrorPage /> : <ConnectionsPage />}
    </>
  );
}
